export { default as translations } from './translations.json';

const CODE_REGEX = /^[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}-[A-Z0-9]{4}$/;

/**
 * Validate gift card code format.
 * @param {string} code
 * @returns {boolean}
 */
export const isValidCodeFormat = (code) =>
  CODE_REGEX.test(code?.toUpperCase().trim() || '');

/**
 * Check if gift card is expired.
 * @param {{ expiresAt: string | null }} card
 * @param {Date} [now]
 * @returns {boolean}
 */
export const isExpired = (card, now = new Date()) =>
  !!card?.expiresAt && new Date(card.expiresAt) < now;

/**
 * Get remaining balance.
 * @param {{ balanceCents: number, usedCents: number }} card
 * @returns {number}
 */
export const getRemainingBalance = (card) =>
  (card?.balanceCents || 0) - (card?.usedCents || 0);
